// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._rbgIhBEYP72Qp5wn2EY {
  border: 0.5px solid #C1C1C1;
  width: auto;
  color: rgb(100, 99, 99);
  z-index: 0;
  height: 24px;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.25px;
}

.eEVozfYnLEFDQshkSEy8 {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  padding-inline: 8px;
  gap: 8px;
  flex: 1;
}

.l0DyNlTbtM4yuAfsUdCi {
  flex-grow: 1;
  text-align: center;
}

.iGOGyoIeKH6BGe5b3kDi {
  font-size: 1.2em;
  vertical-align: middle;
}

.yi5MGOgrJ5uM7GAk3wLr {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/componentes/Tabela/TabelaCabecalhoCelula/TabelaCabecalhoCelula.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EAEA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;AAAF;;AAGA;EACE,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF","sourcesContent":[".headerCell {\r\n  border: 0.5px solid #C1C1C1;\r\n  width: auto;\r\n  color: rgba(100, 99, 99, 1);\r\n  z-index: 0;\r\n\r\n  height: 24px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  line-height: 14px;\r\n  letter-spacing: 0.25px;\r\n}\r\n\r\n.columnCell {\r\n  display: flex;\r\n  position: relative;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-inline: 8px;\r\n  gap: 8px;\r\n  flex: 1;\r\n}\r\n\r\n.columnTitle {\r\n  flex-grow: 1;\r\n  text-align: center;\r\n}\r\n\r\n.sortIcon {\r\n  font-size: 1.2em;\r\n  vertical-align: middle;\r\n}\r\n\r\n.rotatedIcon {\r\n  transform: rotate(180deg);\r\n}"],"sourceRoot":""}]);
// Exports
export var headerCell = `_rbgIhBEYP72Qp5wn2EY`;
export var columnCell = `eEVozfYnLEFDQshkSEy8`;
export var columnTitle = `l0DyNlTbtM4yuAfsUdCi`;
export var sortIcon = `iGOGyoIeKH6BGe5b3kDi`;
export var rotatedIcon = `yi5MGOgrJ5uM7GAk3wLr`;
export default ___CSS_LOADER_EXPORT___;
